// React 18: shadcn's current templates are React-19 style (ref is a plain
// prop, no forwardRef). Every wrapper forwards its ref here, or Radix's
// Slot/Presence (asChild triggers, portal overlays) can't reach the DOM
// node — focus return and exit animations break and React warns.
// Regenerate + re-apply (projects/tailwind-migration).
import { forwardRef } from "react";
("use client");

import { cn } from "@/lib/utils";
import { Switch as SwitchPrimitive } from "radix-ui";

const Switch = forwardRef(function Switch(
  { className, size = "default", ...props },
  ref,
) {
  return (
    <SwitchPrimitive.Root
      ref={ref}
      data-slot="switch"
      data-size={size}
      className={cn(
        "peer group/switch inline-flex shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-[1.15rem] data-[size=default]:w-8 data-[size=sm]:h-3.5 data-[size=sm]:w-6 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input dark:data-[state=unchecked]:bg-input/80",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0 dark:data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-foreground",
        )}
      />
    </SwitchPrimitive.Root>
  );
});

export { Switch };
